import * as React from "react";
import { Input, Icon, Button, Form } from "antd";
import { PasswordKeys } from "../../../common/Constants";
import { TPasswordChangePresentationModel } from "../../../presenter/authentication/ChangePasswordPresenter";

const PasswordChangeForm = ({
  password,
  translate,
  setPasswordValue,
  disableButton,
  changePassword,
  validationErrors,
  goBack,
  isPasswordExpired = false,
  loading
}: {
  password: TPasswordChangePresentationModel;
  translate: any;
  setPasswordValue: (key: string, value: string) => void;
  disableButton: boolean;
  changePassword: any;
  validationErrors: any;
  goBack?: any;
  isPasswordExpired?: boolean;
  loading: boolean;
}) => {
  const oldPasswordErrors = validationErrors[PasswordKeys.OLD_PASSWORD];
  const newPasswordErrors = validationErrors[PasswordKeys.NEW_PASSWORD];
  const confirmPasswordErrors =
    validationErrors[PasswordKeys.CONFIRM_NEW_PASSWORD];
  return (
    <div
      style={{
        width: "40%",
        height: isPasswordExpired ? 190 : 250,
        display: "flex",
        background: "#f0f2f5",
        justifyContent: "space-between",
        flexDirection: "column",
        padding: 10
      }}
    >
      <Form style={{display: "contents"}}>
        {!isPasswordExpired && (
          <Form.Item
            validateStatus={oldPasswordErrors ? "error" : "success"}
            help={
              translate(`settings.password.${oldPasswordErrors}`) || undefined
            }
          >
            <Input.Password
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder={translate("settings.password.old_password")}
              value={password.oldPassword}
              onChange={e =>
                setPasswordValue(PasswordKeys.OLD_PASSWORD, e.target.value)
              }
              allowClear={true}
            />
          </Form.Item>
        )}
        <Form.Item
          validateStatus={newPasswordErrors ? "error" : "success"}
          help={
            translate(`settings.password.${newPasswordErrors}`) || undefined
          }
        >
          <Input.Password
            prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder={translate("settings.password.new_password")}
            value={password.newPassword}
            onChange={e =>
              setPasswordValue(PasswordKeys.NEW_PASSWORD, e.target.value)
            }
            allowClear={true}
          />
        </Form.Item>
        <Form.Item
          validateStatus={confirmPasswordErrors ? "error" : "success"}
          help={
            translate(
              `settings.password.${
                confirmPasswordErrors && confirmPasswordErrors.length > 1
                  ? confirmPasswordErrors[0]
                  : confirmPasswordErrors
              }`
            ) || undefined
          }
        >
          <Input.Password
            prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder={translate("settings.password.confirm_new_password")}
            value={password.confirmNewPassword}
            onChange={e =>
              setPasswordValue(
                PasswordKeys.CONFIRM_NEW_PASSWORD,
                e.target.value
              )
            }
            allowClear={true}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            disabled={disableButton}
            onClick={changePassword}
            loading={loading}
          >
            {translate("settings.password.change")}
          </Button>
          {goBack && (
            <Button type="link" onClick={goBack} loading={false}>
              {translate("settings.password.go_back")}
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default PasswordChangeForm;
